import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_AD_UNIT_BIDDERS: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query getAdUnitBidders($adUnitId: ID!) {
    adUnitBidders(adUnitId: $adUnitId) {
      nodes {
        csEnabled
        csRequiredParams
        domainBidderId
        fieldAlerts {
          ...AlertFragment
        }
        id
        s2sEnabled
        s2sRequiredParams
        workspaceBidder {
          accountType
          bidder {
            id
            name
            s2sAvailable
          }
          bidderCode
          id
          status
        }
        updatedAt
      }
    }
  }
`
